import { bingoSelectors } from '@/shared/constants/bingo';

export type BingoCustomerName = {
  first: string | null;
  last: string | null;
};

const clean = (raw: string | null | undefined): string | null =>
  raw?.trim() || null;

// Liquid knows the Shopify customer's name even when the bingo API does not:
// shopify-cognito-app mints a pass whose `name` claim is an empty string for any
// customer whose local identity row was created without one (Shop login supplies
// no name), and it never back-fills. The section therefore emits the name
// server-side so the app has a source that does not depend on that claim.
export const readCustomerName = (): BingoCustomerName => {
  const mount = document.getElementById(bingoSelectors.MOUNT_ID);

  return {
    first: clean(mount?.dataset.customerFirstName),
    last: clean(mount?.dataset.customerLastName)
  };
};
